<template>
  <v-layout :style="{ height: blockHeight + 'px' }">
    <GroupedTable
      :groups="groups"
      :sub-groups="subGroups"
      :headers="headers"
      :flat-items="packagesItems"
      @action="openDialog"
    />

    <v-dialog
      v-if="editDialog"
      v-model="editDialog"
      width="1000"
      persistent
    >
      <v-card>
        <v-card-title>
          <h2 class="subheading font-weight-bold">
            Данные по грузу Поставки №<span>{{ item.title }}</span>
          </h2>
        </v-card-title>
        <v-progress-linear
          v-if="loadingItemPackages"
          indeterminate
          height="2"
          value="1"
          color="primary"
          class="mb-0"
        />
        <v-layout
          v-else
          column
        >
          <v-card-text class="pt-0">
            <Packages
              v-model="itemPackages"
              :shipping-info="shippingInfo"
            />
          </v-card-text>
          <v-card-actions>
            <v-btn
              small
              color="primary"
              :loading="loadingSavePackages"
              @click="savePackages"
            >
              Сохранить
            </v-btn>
            <v-btn
              small
              @click="closeEditdialog"
            >
              Отмена
            </v-btn>
          </v-card-actions>
        </v-layout>
      </v-card>
    </v-dialog>
  </v-layout>
</template>
<script>
import GroupedTable from "../../../../components/GroupedTable.vue";
import Packages from "../../../shippings/components/new-shipping/Packages.vue";
import tableHeaders from "./grouped-table-headers.js";
import groupedTableGroups from "./grouped-table-groups.js";
import groupedTableSubGroups from "./grouped-table-subgroups.js";
import { packages } from "../../../package-types/packages.js";
import {
  getPackagesInfo,
  changePackagesInfo,
} from "../../../../backend/routesApi.js";
export default {
  components: { GroupedTable, Packages },
  props: ["routePackages", "blockHeight", "routeId"],
  data() {
    return {
      packagesItems: [],
      headers: tableHeaders.groupedTableHeaders,
      groups: groupedTableGroups,
      subGroups: groupedTableSubGroups,
      itemPackages: [],
      item: null,
      editDialog: false,
      loadingItemPackages: false,
      loadingSavePackages: false,
      shippingInfo: null,
    };
  },
  computed: {
    packageTypes() {
      return packages;
    },
  },
  watch: {
    routePackages: {
      handler(value) {
        if (!value.length) {
          return;
        }
        this.initPackages(value);
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    initPackages(items) {
      this.packagesItems = items.map(i => {
        const item = { ...i };
        if (i.oversize) {
          item.group = "Негабарит";
        } else {
          if (i.type === this.packageTypes.PalletEuro.id && !i.oversize) {
            item.group = "Паллеты";
            item.subGroup = "ЕВРО";
            item.defaultSubGroupValues = {
              length: 1.2,
              width: 0.8,
            };
          }
          if (i.type === this.packageTypes.PalletOther.id && !i.oversize) {
            item.group = "Паллеты";
            item.subGroup = "ДРУГОЕ";
          }
          if (
            i.type !== this.packageTypes.PalletEuro.id &&
            i.type !== this.packageTypes.PalletOther.id &&
            !i.oversize
          ) {
            item.group = "Иное";
            item.subGroup = "ИНОЕ";
          }
        }
        for (const key in this.packageTypes) {
          if (this.packageTypes[key].id === i.type) {
            item.type = this.packageTypes[key].title;
          }
        }

        return item;
      });
    },
    async openDialog(value) {
      this.loadingItemPackages = true;
      this.editDialog = true;
      this.item = value;
      this.shippingInfo = await getPackagesInfo(this.routeId, value.id);
      this.itemPackages = this.shippingInfo.items;
      this.loadingItemPackages = false;
    },
    async savePackages() {
      this.loadingSavePackages = true;
      const packages = this.itemPackages.map(p => {
        return {
          packageTypeId: p.packageType.id,
          quantity: p.quantity,
          length: p.length,
          width: p.width,
          height: p.height,
        };
      });
      await changePackagesInfo(this.routeId, this.item.id, packages);
      this.$emit("change");
      this.loadingSavePackages = false;
      this.editDialog = false;
    },
    closeEditdialog() {
      this.editDialog = false;
    },
  },
};
</script>
